import { render, staticRenderFns } from "./PrivacyPolicyView.vue?vue&type=template&id=ff3e0cdc"
import script from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyView.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyView.vue?vue&type=style&index=0&id=ff3e0cdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports